import csTools from "cornerstone-tools";
const MouseCursor = csTools.import("tools/cursors/MouseCursor");

const pointerCursor = `
  <g filter="url(#filter0_d_227_5)">
    <path  viewBox="0 0 24 28" fill-rule="evenodd" clip-rule="evenodd" d="M8 20L20 8L8 8L8 20Z" fill="#4CFFCE"/>
  </g>

  <defs>
  <filter id="filter0_d_227_5" x="-4" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="4"/>
  <feGaussianBlur stdDeviation="2"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_227_5"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_227_5" result="shape"/>
  </filter>
  </defs>
`;

export const defaultPolylineCursor = new MouseCursor(
  `<g filter="url(#filter0_d_225_4)">
  <path d="M27.6793 0.188861C27.5482 0.0837667 27.389 0.0195301 27.2217 0.00413807C27.0544 -0.011254 26.8862
  0.0228774 26.7381 0.102289L17.6591 4.97177L5.17121 0.0602883C5.013 -0.0019013 4.83986 -0.0156401 4.67382
  0.0208184C4.50777 0.0572769 4.35632 0.142286 4.23871 0.265039C4.1211 0.387791 4.04265 0.542743 4.01333
  0.710194C3.98401 0.877646 4.00515 1.05003 4.07405 1.20544L9.58985 13.617C9.09432 14.005 8.71627 14.523
  8.49783 15.1133C8.27939 15.7035 8.22913 16.3428 8.35266 16.9599C8.47619 17.5771 8.76866 18.1478 9.19747
  18.6084C9.62629 19.0691 10.1746 19.4017 10.7813 19.5691C10.6176 20.3371 10.1955 21.0258 9.58544 21.5202C8.97538
  22.0147 8.21424 22.2851 7.42896 22.2862H5.71465V24.0005H7.42896C8.66101 23.9984 9.85139 23.5543 10.7838 22.749C11.7162
  21.9436 12.3288 20.8305 12.5102 19.6119C13.1128 19.4659 13.6646 19.1592 14.1069 18.7245C14.5491 18.2898 14.8652 17.7434
  15.0217 17.1433H22.2063C22.5811 17.1433 22.9454 17.0205 23.2438 16.7937C23.5421 16.5669 23.7578 16.2487 23.8581
  15.8876L27.969 1.08716C28.0141 0.925381 28.0107 0.753919 27.9592 0.594066C27.9077 0.434213 27.8103 0.29387
  27.6793 0.188861ZM11.7147 18.0005C11.3757 18.0005 11.0442 17.8999 10.7623 17.7116C10.4804 17.5232 10.2607
  17.2555 10.1309 16.9422C10.0012 16.629 9.96722 16.2843 10.0334 15.9517C10.0995 15.6192 10.2628 15.3137
  10.5025 15.074C10.7423 14.8342 11.0478 14.671 11.3803 14.6048C11.7128 14.5387 12.0575 14.5726 12.3708
  14.7024C12.684 14.8321 12.9518 15.0518 13.1401 15.3338C13.3285 15.6157 13.4291 15.9471 13.4291 16.2862C13.4286
  16.7407 13.2478 17.1765 12.9264 17.4979C12.605 17.8193 12.1693 18 11.7147 18.0005ZM22.2063 15.429H15.0217C14.8241
  14.5929 14.312 13.8651 13.5918 13.3967C12.8715 12.9284 11.9985 12.7555 11.1542 12.9141L6.49038 2.42088L17.7706
  6.8575L25.7807 2.56146L22.2063 15.429Z" fill="#4CFFCE"/>
  </g>
  
  <defs>
    <filter id="filter0_d_225_4" x="0.000488281" y="0.000534058" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="4"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_225_4"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_225_4" result="shape"/>
    </filter>
  </defs>`,
  {
    viewBox: {
      x: 32,
      y: 32,
    },
    iconSize: 32,
    mousePointerGroupString: pointerCursor,
  }
);

export const addPolylineCursor = new MouseCursor(
  `<g filter="url(#filter0_d_229_5)">
  <path d="M27.1806 1.00826C27.0865 0.932804 26.9723 0.886685 26.8521 0.875634C26.732 0.864584 26.6112 0.889088
  26.5049 0.946102L19.9867 4.44214L11.021 0.915947C10.9074 0.871298 10.7831 0.861435 10.6639 0.88761C10.5447
  0.913785 10.4359 0.974818 10.3515 1.06295C10.2671 1.15108 10.2107 1.26232 10.1897 1.38255C10.1686 1.50277
  10.1838 1.62653 10.2333 1.73811L14.1933 10.649C13.8376 10.9275 13.5662 11.2994 13.4093 11.7232C13.2525
  12.147 13.2164 12.606 13.3051 13.049C13.3938 13.4921 13.6038 13.9018 13.9116 14.2326C14.2195 14.5633
  14.6132 14.8021 15.0487 14.9222C14.9312 15.4736 14.6282 15.9681 14.1902 16.3231C13.7522 16.6781 13.2057
  16.8722 12.6419 16.873H11.4112V18.1038H12.6419C13.5265 18.1023 14.3811 17.7834 15.0505 17.2052C15.72 16.6271
  16.1598 15.8279 16.29 14.953C16.7227 14.8482 17.1188 14.628 17.4363 14.3159C17.7538 14.0038 17.9808 13.6115
  18.0931 13.1807H23.2513C23.5204 13.1807 23.782 13.0925 23.9961 12.9297C24.2103 12.7669 24.3652 12.5384
  24.4372 12.2791L27.3886 1.65319C27.421 1.53704 27.4186 1.41394 27.3816 1.29917C27.3446 1.18441 27.2747
  1.08365 27.1806 1.00826ZM15.7189 13.7961C15.4755 13.7961 15.2375 13.7239 15.0351 13.5887C14.8327 13.4534
  14.675 13.2612 14.5818 13.0363C14.4887 12.8114 14.4643 12.5639 14.5118 12.3252C14.5593 12.0864 14.6765
  11.8671 14.8486 11.695C15.0207 11.5229 15.24 11.4057 15.4788 11.3582C15.7175 11.3107 15.965 11.335 16.1899
  11.4282C16.4148 11.5214 16.607 11.6791 16.7423 11.8815C16.8775 12.0839 16.9497 12.3219 16.9497 12.5653C16.9494
  12.8916 16.8196 13.2045 16.5889 13.4352C16.3581 13.666 16.0452 13.7958 15.7189 13.7961ZM23.2513 11.9499H18.0931C17.9513
  11.3496 17.5836 10.8271 17.0665 10.4908C16.5494 10.1546 15.9227 10.0305 15.3164 10.1444L11.9681 2.61073L20.0667
  5.796L25.8175 2.71166L23.2513 11.9499Z" fill="#00FF00"/>
  <path d="M7.19381 7.13H4.40381V6.032H7.19381V3.242H8.29181V6.032H11.0998V7.13H8.29181V9.938H7.19381V7.13Z" fill="#00FF00"/>
  </g>
  
  <defs>
  <filter id="filter0_d_229_5" x="0.403809" y="0.873047" width="31.0073" height="25.2308" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="4"/>
  <feGaussianBlur stdDeviation="2"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_229_5"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_229_5" result="shape"/>
  </filter>
  </defs>`,
  {
    viewBox: {
      x: 32,
      y: 27,
    },
    iconSize: 40,
    mousePointerGroupString: pointerCursor,
  }
);

export const removePolylineCursor = new MouseCursor(
  `<g filter="url(#filter0_d_229_13)">
  <path d="M27.181 1.0063C27.0869 0.930851 26.9727 0.884732 26.8525 0.873681C26.7324 0.862631 26.6116
  0.887135 26.5053 0.944148L19.9871 4.44018L11.0214 0.913994C10.9078 0.869345 10.7835 0.859482 10.6643
  0.885657C10.5451 0.911832 10.4363 0.972864 10.3519 1.06099C10.2675 1.14912 10.2111 1.26037 10.1901
  1.38059C10.169 1.50082 10.1842 1.62458 10.2337 1.73616L14.1938 10.647C13.838 10.9256 13.5666 11.2975
  13.4097 11.7213C13.2529 12.145 13.2168 12.604 13.3055 13.0471C13.3942 13.4901 13.6042 13.8999 13.912
  14.2306C14.2199 14.5614 14.6136 14.8001 15.0491 14.9203C14.9316 15.4717 14.6286 15.9661 14.1906 16.3211C13.7526
  16.6761 13.2061 16.8702 12.6423 16.8711H11.4116V18.1019H12.6423C13.5269 18.1003 14.3815 17.7815 15.051
  17.2033C15.7204 16.6251 16.1602 15.826 16.2904 14.9511C16.7231 14.8462 17.1192 14.626 17.4367 14.3139C17.7542
  14.0019 17.9812 13.6095 18.0935 13.1787H23.2517C23.5208 13.1787 23.7824 13.0906 23.9966 12.9277C24.2107
  12.7649 24.3656 12.5364 24.4376 12.2772L27.389 1.65123C27.4214 1.53509 27.419 1.41199 27.382 1.29722C27.345
  1.18245 27.2751 1.08169 27.181 1.0063ZM15.7193 13.7941C15.4759 13.7941 15.2379 13.7219 15.0355 13.5867C14.8331
  13.4515 14.6754 13.2592 14.5822 13.0343C14.4891 12.8094 14.4647 12.562 14.5122 12.3232C14.5597 12.0845 14.6769
  11.8652 14.849 11.6931C15.0211 11.5209 15.2404 11.4037 15.4792 11.3562C15.7179 11.3087 15.9654 11.3331 16.1903
  11.4263C16.4152 11.5194 16.6074 11.6772 16.7427 11.8796C16.8779 12.082 16.9501 12.3199 16.9501 12.5633C16.9498
  12.8897 16.82 13.2025 16.5893 13.4333C16.3585 13.664 16.0456 13.7938 15.7193 13.7941ZM23.2517 11.948H18.0935C17.9517
  11.3477 17.584 10.8251 17.0669 10.4889C16.5498 10.1526 15.9231 10.0285 15.3168 10.1424L11.9685 2.60878L20.0671
  5.79404L25.8179 2.70971L23.2517 11.948Z" fill="#FF0000"/>
  <path d="M4.11621 6.05H9.42621V7.166H4.11621V6.05Z" fill="#FF0000"/>
  </g>
  
  <defs>
  <filter id="filter0_d_229_13" x="0.116211" y="0.871094" width="31.2954" height="25.2308" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="4"/>
  <feGaussianBlur stdDeviation="2"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_229_13"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_229_13" result="shape"/>
  </filter>
  </defs>`,
  {
    viewBox: {
      x: 32,
      y: 27,
    },
    iconSize: 40,
    mousePointerGroupString: pointerCursor,
  }
);
